import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    fetchCollaborators,
    addCollaborator,
    deletellaborator, // Mantenemos el nombre de tu API de Axios
} from "../../api/administration/serviceOrderApi";

export const useCollaborators = (serviceOrderId, options = {}) => {
    const queryClient = useQueryClient();
    const { enabled = true } = options;

    const queryEnabled = Boolean(serviceOrderId) && Boolean(enabled);

    const {
        data: colaboradores = [],
        error,
        isLoading,
        refetch,
    } = useQuery({
        queryKey: ["collaborators", serviceOrderId],
        queryFn: () => fetchCollaborators(serviceOrderId),
        enabled: queryEnabled,
        retry: false,
        staleTime: 0,
        refetchOnWindowFocus: true,
    });

    const invalidateCollaboratorsCache = () => {
        queryClient.invalidateQueries({
            queryKey: ["collaborators", serviceOrderId],
        });
    };

    const addCollaboratorMutation = useMutation({
        mutationFn: (data) => addCollaborator(serviceOrderId, data),
        onSuccess: invalidateCollaboratorsCache,
    });

    const deleteCollaboratorMutation = useMutation({
        mutationFn: (data) => deletellaborator(serviceOrderId, data),
        onSuccess: invalidateCollaboratorsCache,
    });

    return {
        colaboradores: queryEnabled ? colaboradores : [],
        error,
        isLoading,
        refetch,
        addCollaboratorMutation,
        deleteCollaboratorMutation,
        isBusy: addCollaboratorMutation.isPending || deleteCollaboratorMutation.isPending || addCollaboratorMutation.isLoading || deleteCollaboratorMutation.isLoading,
    };
};